module.exports = __webpack_public_path__ + "static/iphone-11e0c2ba7d6d66d55af06382fd7b01d4.jpg";